import qs from 'qs'
import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'
import { USER } from '../users'

export const collection = 'deletedUsers'
export const deletedUserSchema = new schemas.Entity(
  collection,
  { user: USER.schema },
  {
    idAttribute: (value) => value.user?.id,
  }
)
export const schema = new schemas.Array(deletedUserSchema)

type FetchDeletedUsersBodyT = {
  offset: number
  pagesize?: number
  searchTerm?: string
}

export const fetch =
  (callApi: CallApi, apiBase: string) =>
  (_: undefined, body: FetchDeletedUsersBodyT) => {
    return callApi(
      `${apiBase}/deleted-users${qs.stringify(
        { ...body },
        { addQueryPrefix: true }
      )}`,
      schema
    )
  }
